export type CsvFileReadReason = 'unreadable' | 'interrupted' | 'empty-result';

export class CsvFileReadError extends Error {
    readonly reason: CsvFileReadReason;

    constructor(message: string, reason: CsvFileReadReason) {
        super(message);
        this.name = 'CsvFileReadError';
        this.reason = reason;
    }
}

export function readFileAsText(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            if (typeof reader.result !== 'string') {
                reject(new CsvFileReadError('Could not read file', 'empty-result'));
                return;
            }

            resolve(reader.result);
        };

        reader.onerror = () => {
            reject(new CsvFileReadError('Could not read file', 'unreadable'));
        };

        reader.onabort = () => {
            reject(new CsvFileReadError('File reading was interrupted.', 'interrupted'));
        };

        reader.readAsText(file);
    });
}
